import component from "containers/StaticPages/pages/About";

export default {
  key: "powur-our-team",
  title: "Powur Team",
  path: "/:user?/about",
  pageName: "team",
  linkTarget: "/about",
  component,
};
